import { render, staticRenderFns } from "./WinNumber.vue?vue&type=template&id=5424dea0&scoped=true&"
import script from "./WinNumber.vue?vue&type=script&lang=js&"
export * from "./WinNumber.vue?vue&type=script&lang=js&"
import style0 from "./WinNumber.vue?vue&type=style&index=0&id=5424dea0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5424dea0",
  null
  
)

export default component.exports